import AppLanguageSelector from './AppLanguageSelector';

export default AppLanguageSelector